var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShowOff = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 16c-3.559 0-6.183-2.184-7.948-4C5.817 10.184 8.44 8 12 8a4 4 0 1 0 0 8m0 0a4 4 0 0 0 0-8c3.559 0 6.183 2.184 7.948 4-1.765 1.816-4.389 4-7.948 4m0 1.5c5 0 8.333-3.667 10-5.5-1.667-1.833-5-5.5-10-5.5S3.667 10.167 2 12c1.667 1.833 5 5.5 10 5.5m2.5-5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0",
    clipRule: "evenodd"
  })));
};
export default SvgShowOff;